import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import {
  EDITORIAL_PDP_ACCORDION_CONTAINER_CONVERTER_TOKEN, EditorialPDPAccordionContainerConverter
} from './editorial-pdp-accordion-container.component.converter'
import {
  ACCORDION_ITEM_PIM_RESOURCES_CONVERTER_TOKEN, AccordionItemPimResourcesConverter
} from './accordion-item-pim-resources/accordion-item-pim-resources.component.converter'
import {
  ACCORDION_ITEM_PIM_REFERENCES_CONVERTER_TOKEN, AccordionItemPimReferencesConverter
} from './accordion-item-pim-references/accordion-item-pim-references.component.converter'
import {
  ACCORDION_ITEM_PIM_MANUALS_CONVERTER_TOKEN, AccordionItemPimManualsConverter
} from './accordion-item-pim-manuals/accordion-item-pim-manuals.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        editorialPDPAccordionContainerFeature: {
          module: () => import('./editorial-pdp-accordion-container.module').then((m) => m.EditorialPdpAccordionContainerModule),
          cmsComponents: ['editorial_pdp_accordion_main_content_container'],
        },
      }
    }),
    {
      provide: EDITORIAL_PDP_ACCORDION_CONTAINER_CONVERTER_TOKEN,
      useExisting: EditorialPDPAccordionContainerConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        editorial_pdp_accordion_main_content_container: EDITORIAL_PDP_ACCORDION_CONTAINER_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: ACCORDION_ITEM_PIM_RESOURCES_CONVERTER_TOKEN,
      useExisting: AccordionItemPimResourcesConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        accordion_item_pim_resources: ACCORDION_ITEM_PIM_RESOURCES_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: ACCORDION_ITEM_PIM_REFERENCES_CONVERTER_TOKEN,
      useExisting: AccordionItemPimReferencesConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        accordion_item_pim_references: ACCORDION_ITEM_PIM_REFERENCES_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: ACCORDION_ITEM_PIM_MANUALS_CONVERTER_TOKEN,
      useExisting: AccordionItemPimManualsConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        accordion_item_pim_manuals: ACCORDION_ITEM_PIM_MANUALS_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class EditorialPdpAccordionContainerFeatureModule {}
